import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Typography from '@/v2/components/common/Typography'
import { useSnackbarContext } from '@/v2/contexts/SnackbarContext'
import { usePatientContext } from '@/v2/contexts/PatientContext'
import useModals from '@/v2/hooks/useModals'
import { useInsurances } from '@/v2/hooks/insurance/useInsurances'
import Button from '@/v2/components/common/Button'
import Box from '@mui/material/Box'
import InsuranceInfo from './InsuranceInfo'

const InsurancesTab = ({ onEligibilityCheckClick }) => {
  const { goTo } = useModals()
  const { id } = useParams()
  const { patient } = usePatientContext()
  const { insurances, isLoading, isError } = useInsurances(id)
  const { onOpenSnackbar } = useSnackbarContext()

  useEffect(() => {
    if (!isLoading && !!isError) {
      onOpenSnackbar(
        "It wasn't possible to load the patient insurances.",
        'error'
      )
    }
  }, [isLoading, isError, onOpenSnackbar])

  if (isLoading) {
    return (
      <Typography
        variant="h5"
        fontWeight="300"
        sx={{ textAlign: 'center', marginTop: '40px' }}
      >
        Loading...
      </Typography>
    )
  }

  return (
    <>
      {insurances.map(item => (
        <InsuranceInfo
          key={item.id}
          insurance={item}
          patient={patient}
          onEligibilityCheckClick={onEligibilityCheckClick}
        />
      ))}

      {insurances.length === 0 && (
        <Typography
          variant="h5"
          fontWeight="300"
          sx={{ textAlign: 'center', marginTop: '40px' }}
        >
          No insurances found
        </Typography>
      )}
    </>
  )
}

export default InsurancesTab
